/* eslint-disable max-lines */
/* eslint-disable  */

import { l10n } from 'i18n/i18nUtil';
import {
  AuthznRouteConstants,
  NODE_TYPES_MAPPING,
  PRODUCT_NAME_CONSTANTS
} from 'vrlcm-gui-constants';
import { Request, RequestName } from 'vrlcm-gui-types';
import { gte, safeJsonParse, toSafeUIData } from 'vrlcm-gui-utils';
import { ROUTES } from './RouteConstants';
import { ROUTES as CLOUD_ROUTES } from '../../cloud/constants/RouteConstants';

export const PRODUCT_SHORT = {
  esrsve: 'ESRS',
  horizon: 'HRZN',
  nsx: 'NSX',
  nsxt: 'NSX-T',
  vidm: 'vIDM',
  vra: 'Automation',
  vrbc: 'vRBC',
  vrli: 'Logs',
  vrni: 'Networks',
  vrops: 'Operations',
  vsan: 'vSAN',
  vvd: 'VVD',
  vssc: 'Automation Config',
  vro: 'Orchestrator',
  vrnicloudproxy: 'Networks CP',
  vropscloudproxy: 'Operations CP',
  cloudproxy: 'DC VA',
  abxcloudproxy: 'CEXP'
};

export const VSSC_STANDALONE_TENANT = 'Standalone vRASSC';
export const VSSC_BASE_TENANT = 'base tenant';
export const VRO_BASE_TENANT = 'base tenant';

export const FIELD_MAPPING = {
  sourceEndpointName: l10n('migrate.contentMapping.cloudSource'),
  destinationEnvironmentName: l10n('migrate.contentMapping.onPremDestination'),
  contentCredentials: l10n('migrate.migrationWizard.endpointCredentials'),
  existingCollector: l10n('migrate.contentMapping.existingCollector'),
  smtpRequired: l10n('lcops.settings.smtp.label.smtpRequired'),
  sourceIpaddress: l10n(
    'lcops.createEnvironment.products.advancedConfig.sourceCollectorIPAddress'
  ),
  ipaddress: l10n(
    'locker.certificates.addCertificate.addCertificateForm.ipAddress'
  ),
  destinationPassword: l10n('migrate.contentMapping.destinationPassword'),
  smtpConfiguration: l10n('lcops.settings.smtp.details.title'),
  installationType: l10n(
    'lcops.createEnvironment.selectProduct.installationType'
  ),
  contents: l10n('migrate.migrationWizard.contents'),
  contentManagement: l10n('migrate.migrationWizard.contentManagement'),
  acceptEULA: l10n('appConstants.fieldMapping.acceptEULA'),
  fromEmail: l10n('lcops.settings.smtp.label.senderEmail'),
  smtpHostName: l10n('lcops.settings.smtp.label.smtpHostName'),
  encryptionType: l10n('lcops.settings.smtp.label.encryption'),
  smtpEncryptionPort: l10n('lcops.settings.smtp.label.smtpPortNumber'),
  authenticationRequired: l10n(
    'lcops.settings.smtp.label.authenticationRequired'
  ),
  nodes: l10n('migrate.nodeMapping.collectorConfiguration'),
  companyname: l10n('companyName'),
  node: l10n('migrate.nodeMapping.node'),
  skipItem: l10n('migrate.contentManagement.skipItems'),
  adaptorsDetails: l10n('migrate.migrationWizard.adapters'),
  adaptors: l10n('migrate.migration-wizard.adapter-list.adapterDetails'),
  NOT_SUPPORTED: l10n('migrate.migration-wizard.adapter-list.unsupported'),
  INSTALLED: l10n(
    'migrate.migration-wizard.adapter-list.installedIntegrations'
  ),
  TO_BE_INSTALLED: l10n(
    'migrate.migration-wizard.adapter-list.availableIntegrations'
  ),
  CANNOT_BE_INSTALLED: l10n(
    'migrate.migration-wizard.adapter-list.installationUnavailable'
  ),
  userMapping: l10n('migrate.summary.userMapping'),
  configurations: l10n('migrate.migrationWizard.configurations'),
  userInformation: l10n('migrate.migration-wizard.adapter-list.userDetails'),
  productType: l10n('migrate.contentMapping.productType'),
  collectorMapping: l10n('migrate.summary.collectorMapping'),
  encryptionPassword: l10n('migrate.contentManagement.encryptionPassword'),
  orgId: l10n('migrate.contentMapping.cloudSource'),
  sourceEndpointId: 'Source Endpoint ID',
  migrationName: l10n('migrate.contentMapping.migrationName'),
  adapterFiles: l10n('appConstants.fieldMapping.adapterFiles'),
  appliedOn: l10n('appConstants.fieldMapping.appliedOn'),
  address: l10n('appConstants.fieldMapping.address'),
  adminEmail: l10n('appConstants.fieldMapping.adminEmail'),
  adminGroup: l10n('appConstants.fieldMapping.adminGroup'),
  adminGroupDomain: l10n('appConstants.fieldMapping.adminGroupDomain'),
  adminPassword: l10n('appConstants.fieldMapping.adminPassword'),
  adminUserName: l10n('appConstants.fieldMapping.adminUserName'),
  adName: l10n('appConstants.fieldMapping.adName'),
  affinityRule: l10n('appConstants.fieldMapping.affinityRule'),
  affinityRules: l10n('appConstants.fieldMapping.affinityRules'),
  agentName: l10n('appConstants.fieldMapping.agentName'),
  agentPassword: l10n('appConstants.fieldMapping.agentPassword'),
  agentUserName: l10n('appConstants.fieldMapping.agentUserName'),
  autoLogonCount: l10n('appConstants.fieldMapping.autoLogonCount'),
  authenticationType: l10n('appConstants.fieldMapping.authenticationType'),
  baseDN: l10n('appConstants.fieldMapping.baseDN'),
  bindDN: l10n('appConstants.fieldMapping.bindDN'),
  cafeCertificate: l10n('appConstants.fieldMapping.cafeCertificate'),
  cafeHost: l10n('appConstants.fieldMapping.cafeHost'),
  cafeHostName: l10n('appConstants.fieldMapping.cafeHostName'),
  cafeHostNamePrimary: l10n('appConstants.fieldMapping.cafeHostNamePrimary'),
  cafeRootPassword: l10n('appConstants.fieldMapping.cafeRootPassword'),
  cafeRootPasswordPrimary: l10n(
    'appConstants.fieldMapping.cafeRootPasswordPrimary'
  ),
  capacity: l10n('appConstants.fieldMapping.capacity'),
  category: l10n('appConstants.fieldMapping.category'),
  certificate: l10n('appConstants.fieldMapping.certificate'),
  certificateAlias: l10n('appConstants.fieldMapping.certificateAlias'),
  certificateChain: l10n('appConstants.fieldMapping.certificateChain'),
  cluster: l10n('appConstants.fieldMapping.cluster'),
  clusterFqdn: l10n('appConstants.fieldMapping.clusterFqdn'),
  clusterName: l10n('appConstants.fieldMapping.clusterName'),
  clusterVip: l10n('appConstants.fieldMapping.clusterVip'),
  collectorGroupName: l10n('appConstants.fieldMapping.collectorGroupName'),
  componentusername: l10n('appConstants.fieldMapping.componentusername'),
  componentuserpassword: l10n(
    'appConstants.fieldMapping.componentuserpassword'
  ),
  configureAffinitySeparateAll: l10n(
    'appConstants.fieldMapping.configureAffinitySeparateAll'
  ),
  controllerType: l10n('appConstants.fieldMapping.controllerType'),
  cpuCount: l10n('appConstants.fieldMapping.cpuCount'),
  customPort: l10n('appConstants.fieldMapping.vIDBCustomPort'),
  isUpgradeVmCompatibility: l10n(
    'appConstants.fieldMapping.isUpgradeVmCompatibility'
  ),
  vrliAlwaysUseEnglish: l10n('appConstants.fieldMapping.vrliAlwaysUseEnglish'),
  configureClusterVIP: l10n('appConstants.fieldMapping.configureClusterVIP'),
  configureVropsAdapter: l10n(
    'appConstants.fieldMapping.configureVropsAdapter'
  ),
  configureWindowVM: l10n('appConstants.fieldMapping.configureWindowVM'),
  consolePassword: l10n('appConstants.fieldMapping.consolePassword'),
  contentLibrary: l10n('appConstants.fieldMapping.contentLibrary'),
  currency: l10n('appConstants.fieldMapping.currency'),
  currentPatch: l10n('appConstants.fieldMapping.currentPatch'),
  databaseName: l10n('appConstants.fieldMapping.databaseName'),
  databasePassword: l10n('appConstants.fieldMapping.databasePassword'),
  databaseUserName: l10n('appConstants.fieldMapping.databaseUserName'),
  dataCenterName: l10n('appConstants.fieldMapping.dataCenterName'),
  dataCenterVmid: l10n('appConstants.fieldMapping.dataCenterVmid'),
  datastoreName: l10n('appConstants.fieldMapping.datastoreName'),
  dbInstance: l10n('appConstants.fieldMapping.dbInstance'),
  defaultConfigurationEmail: l10n(
    'appConstants.fieldMapping.defaultConfigurationEmail'
  ),
  defaultConfigurationUsername: l10n(
    'appConstants.fieldMapping.defaultConfigurationUsername'
  ),
  defaultConfigurationPassword: l10n(
    'appConstants.fieldMapping.defaultConfigurationPassword'
  ),
  defaultPassword: l10n('appConstants.fieldMapping.defaultPassword'),
  demName: l10n('appConstants.fieldMapping.demName'),
  demPassword: l10n('appConstants.fieldMapping.demPassword'),
  demUserName: l10n('appConstants.fieldMapping.demUserName'),
  demWorker: l10n('appConstants.fieldMapping.demWorker'),
  deployOption: l10n('appConstants.fieldMapping.deployOption'),
  disableTls: l10n('appConstants.fieldMapping.disableTls'),
  diskFormat: l10n('appConstants.fieldMapping.diskFormat'),
  diskMode: l10n('appConstants.fieldMapping.diskMode'),
  description: l10n('appConstants.fieldMapping.description'),
  dns: l10n('appConstants.fieldMapping.dns'),
  domain: l10n('appConstants.fieldMapping.domain'),
  Domain: l10n('appConstants.fieldMapping.vIDBDomain'),
  domainAdmin: l10n('appConstants.fieldMapping.domainAdmin'),
  domainAdminPassword: l10n('appConstants.fieldMapping.domainAdminPassword'),
  enablePostgresDbSyncMode: l10n(
    'appConstants.fieldMapping.enablePostgresDbSyncMode'
  ),
  enableTelemetry: l10n('appConstants.fieldMapping.enableTelemetry'),
  enableVidmManagerIntegration: l10n(
    'appConstants.fieldMapping.enableVidmManagerIntegration'
  ),
  enableVroConfigurator: l10n(
    'appConstants.fieldMapping.enableVroConfigurator'
  ),
  environmentId: l10n('appConstants.fieldMapping.environmentId'),
  environmentName: l10n('appConstants.fieldMapping.environmentName'),
  esxHost: l10n('appConstants.fieldMapping.esxHost'),
  esxHostBuild: l10n('appConstants.fieldMapping.esxHostBuild'),
  'ESXI Version': l10n('appConstants.fieldMapping.esxiVersion'),
  extendStorage: l10n('appConstants.fieldMapping.extendStorage'),
  extendedStorage: l10n('appConstants.fieldMapping.extendedStorage'),
  folderName: l10n('appConstants.fieldMapping.folderName'),
  fullName: l10n('appConstants.fieldMapping.fullName'),
  gateway: l10n('appConstants.fieldMapping.gateway'),
  ipv6Gateway: l10n('appConstants.fieldMapping.ipv6Gateway'),
  groupDN: l10n('appConstants.fieldMapping.groupDN'),
  hostname: l10n('appConstants.fieldMapping.hostname'),
  hostName: l10n('appConstants.fieldMapping.hostName'),
  iaasManager: l10n('appConstants.fieldMapping.iaasManager'),
  iaasSecurityPassphrase: l10n(
    'appConstants.fieldMapping.iaasSecurityPassphrase'
  ),
  iaasUserName: l10n('appConstants.fieldMapping.iaasUserName'),
  iaasweb: l10n('appConstants.fieldMapping.iaasweb'),
  installationPath: l10n('appConstants.fieldMapping.installationPath'),
  installerLocation: l10n('appConstants.fieldMapping.installerLocation'),
  installInitialContent: l10n(
    'appConstants.fieldMapping.installInitialContent'
  ),
  ip: l10n('appConstants.fieldMapping.ip'),
  ipv6: l10n('appConstants.fieldMapping.ipv6'),
  isoFileName: l10n('appConstants.fieldMapping.isoFileName'),
  isAutologon: l10n('appConstants.fieldMapping.isAutologon'),
  isCaEnabled: l10n('appConstants.fieldMapping.isCaEnabled'),
  isDomainJoined: l10n('appConstants.fieldMapping.isDomainJoined'),
  isPhysicalFlowCollector: l10n(
    'appConstants.fieldMapping.isPhysicalFlowCollector'
  ),
  isStandalone: l10n('appConstants.fieldMapping.isStandalone'),
  isTelemetryEnable: l10n('appConstants.fieldMapping.isTelemetryEnable'),
  isVcfEnabledEnv: l10n('appConstants.fieldMapping.isVcfEnabledEnv'),
  isVcfUser: l10n('appConstants.fieldMapping.isVcfUser'),
  isVrbVidmEnabled: l10n('appConstants.fieldMapping.isVrbVidmEnabled'),
  keyPassphrase: l10n('appConstants.fieldMapping.keyPassphrase'),
  latestPatchVersion: l10n('appConstants.fieldMapping.latestPatchVersion'),
  license: l10n('appConstants.fieldMapping.license'),
  licenseKey: l10n('appConstants.fieldMapping.licenseKey'),
  managerServiceFailoverModeEnabled: l10n(
    'appConstants.fieldMapping.managerServiceFailoverModeEnabled'
  ),
  masterCertificateChain: l10n(
    'appConstants.fieldMapping.masterCertificateChain'
  ),
  masterIP: l10n('appConstants.fieldMapping.masterIP'),
  masterKeyPassphrase: l10n('appConstants.fieldMapping.masterKeyPassphrase'),
  masterNodeAddress: l10n('appConstants.fieldMapping.masterNodeAddress'),
  masterNodeIP: l10n('appConstants.fieldMapping.masterNodeIP'),
  masterPrivateKey: l10n('appConstants.fieldMapping.masterPrivateKey'),
  masterVidmAdminPassword: l10n(
    'appConstants.fieldMapping.masterVidmAdminPassword'
  ),
  masterVidmAdminUserName: l10n(
    'appConstants.fieldMapping.masterVidmAdminUserName'
  ),
  masterVidmCloudAdminGroup: l10n(
    'appConstants.fieldMapping.masterVidmCloudAdminGroup'
  ),
  masterVidmEnabled: l10n('appConstants.fieldMapping.masterVidmEnabled'),
  masterVidmHostname: l10n('appConstants.fieldMapping.masterVidmHostname', [
    PRODUCT_NAME_CONSTANTS.vidm
  ]),
  masterVidmHostName: l10n('appConstants.fieldMapping.masterVidmHostName', [
    PRODUCT_NAME_CONSTANTS.vidm
  ]),
  maVmName: l10n('appConstants.fieldMapping.maVmName'),
  memory: l10n('appConstants.fieldMapping.memory'),
  monitorvRAWithvROps: l10n('appConstants.fieldMapping.monitorvRAWithvROps'),
  monitorvRNIWithvROps: l10n('appConstants.fieldMapping.monitorvRNIWithvROps'),
  msCertificate: l10n('appConstants.fieldMapping.msCertificate'),
  msPassword: l10n('appConstants.fieldMapping.msPassword'),
  msUserName: l10n('appConstants.fieldMapping.msUserName'),
  netmask: l10n('appConstants.fieldMapping.netmask'),
  ipv6Netmask: l10n('appConstants.fieldMapping.ipv6Netmask'),
  network: l10n('appConstants.fieldMapping.network'),
  networkProxySettings: l10n('appConstants.fieldMapping.networkProxySettings'),
  networkProxyHostnameOrIp: l10n(
    'appConstants.fieldMapping.networkProxyHostnameOrIp'
  ),
  networkProxyPort: l10n('appConstants.fieldMapping.networkProxyPort'),
  networkProxyUsername: l10n('appConstants.fieldMapping.networkProxyUsername'),
  networkProxyPassword: l10n('appConstants.fieldMapping.networkProxyPassword'),
  nodeInfra: l10n('appConstants.fieldMapping.nodeInfra'),
  nodeNetwork: l10n('appConstants.fieldMapping.nodeNetwork'),
  nodeSize: l10n('appConstants.fieldMapping.nodeSize'),
  nodeType: l10n('appConstants.fieldMapping.nodeType'),
  ntp: l10n('appConstants.fieldMapping.ntp'),
  ntpData: l10n('appConstants.fieldMapping.ntpData'),
  ntpServer: l10n('appConstants.fieldMapping.ntpServer'),
  ntpServerIP: l10n('appConstants.fieldMapping.ntpServerIP'),
  orgName: l10n('appConstants.fieldMapping.orgName'),
  password: l10n('appConstants.fieldMapping.password'),
  portNumber: l10n('appConstants.fieldMapping.portNumber'),
  privateKey: l10n('appConstants.fieldMapping.privateKey'),
  platformIP: l10n('appConstants.fieldMapping.platformIP'),
  product_advance_property: l10n(
    'appConstants.fieldMapping.product_advance_property'
  ),
  productPassword: l10n('appConstants.fieldMapping.productPassword'),
  productPatchLevel: l10n('appConstants.fieldMapping.productPatchLevel'),
  proxyAgent: l10n('appConstants.fieldMapping.proxyAgent'),
  regionName: l10n('appConstants.fieldMapping.regionName'),
  registervROpswithvRA: l10n('appConstants.fieldMapping.registervROpswithvRA'),
  resourcePool: l10n('appConstants.fieldMapping.resourcePool'),
  retainSnapshot: l10n('appConstants.fieldMapping.retainSnapshot'),
  rootPassword: l10n('appConstants.fieldMapping.rootPassword'),
  searchpath: l10n('appConstants.fieldMapping.searchpath'),
  securityPassphrase: l10n('appConstants.fieldMapping.securityPassphrase'),
  snapshotPrefix: l10n('appConstants.fieldMapping.snapshotPrefix'),
  snapshotWithMemory: l10n('appConstants.fieldMapping.snapshotWithMemory'),
  sshEnabled: l10n('appConstants.fieldMapping.sshEnabled'),
  ssoAdminUser: l10n('appConstants.fieldMapping.ssoAdminUser'),
  ssoDefaultAdmin: l10n('appConstants.fieldMapping.ssoDefaultAdmin'),
  ssoPassword: l10n('appConstants.fieldMapping.ssoPassword'),
  ssoTenant: l10n('appConstants.fieldMapping.ssoTenant'),
  storage: l10n('appConstants.fieldMapping.storage'),
  summary: l10n('appConstants.fieldMapping.summary'),
  supportPassword: l10n('appConstants.fieldMapping.supportPassword'),
  supportUserName: l10n('appConstants.fieldMapping.supportUserName'),
  syncGroupMembers: l10n('appConstants.fieldMapping.syncGroupMembers'),
  takeSnapshot: l10n('appConstants.fieldMapping.takeSnapshot'),
  template: l10n('appConstants.fieldMapping.template'),
  templateSpec: l10n('appConstants.fieldMapping.templateSpec'),
  tenant: l10n('appConstants.fieldMapping.vIDBTenant'),
  tenantName: l10n('appConstants.fieldMapping.tenantName'),
  tenantUser: l10n('appConstants.fieldMapping.tenantUser'),
  tenantPassword: l10n('appConstants.fieldMapping.tenantPassword'),
  tenantUserName: l10n('appConstants.fieldMapping.tenantUserName'),
  tenantUserPassword: l10n('appConstants.fieldMapping.tenantUserPassword'),
  timeSyncMode: l10n('appConstants.fieldMapping.timeSyncMode'),
  timezone: l10n('appConstants.fieldMapping.timezone'),
  timeZone: l10n('appConstants.fieldMapping.timeZone'),
  uberAdmin: l10n('appConstants.fieldMapping.uberAdmin'),
  urgency: l10n('appConstants.fieldMapping.urgency'),
  user: l10n('appConstants.fieldMapping.vIDBUser'),
  userName: l10n('appConstants.fieldMapping.userName'),
  useComponentCertificate: l10n(
    'appConstants.fieldMapping.useComponentCertificate'
  ),
  useContentRepo: l10n('appConstants.fieldMapping.useContentRepo'),
  useCustomSpec: l10n('appConstants.fieldMapping.useCustomSpec'),
  useExistingDatabase: l10n('appConstants.fieldMapping.useExistingDatabase'),
  username: l10n('appConstants.fieldMapping.username'),
  vCenterHostname: l10n('appConstants.fieldMapping.vIDBVCenterHostname'),
  vraFullVersion: l10n('appConstants.fieldMapping.vraFullVersion'),
  vrliDataInterval: l10n('appConstants.fieldMapping.vrliDataInterval'),
  vrliIntervalUnit: l10n('appConstants.fieldMapping.vrliIntervalUnit'),
  extendHardDiskCapacity: l10n(
    'appConstants.fieldMapping.extendHardDiskCapacity'
  ),
  extendHardDiskFormat: l10n('appConstants.fieldMapping.extendHardDiskFormat'),
  vrliSMTPDefaultSenderEmail: l10n(
    'appConstants.fieldMapping.vrliSMTPDefaultSenderEmail'
  ),
  vrliSMTPIsSSLAuth: l10n('appConstants.fieldMapping.vrliSMTPIsSSLAuth'),
  vrliSMTPIsTLS: l10n('appConstants.fieldMapping.vrliSMTPIsTLS'),
  vrliSMTPLogin: l10n('appConstants.fieldMapping.vrliSMTPLogin'),
  vrliSMTPPassword: l10n('appConstants.fieldMapping.vrliSMTPPassword'),
  vrliSMTPPort: l10n('appConstants.fieldMapping.vrliSMTPPort'),
  vrliSMTPServer: l10n('appConstants.fieldMapping.vrliSMTPServer'),
  vrliADDomain: l10n('appConstants.fieldMapping.vrliADDomain'),
  vrliADDomainControllers: l10n(
    'appConstants.fieldMapping.vrliADDomainControllers'
  ),
  vrliADPort: l10n('appConstants.fieldMapping.vrliADPort'),
  vrliADUsername: l10n('appConstants.fieldMapping.vrliADUsername'),
  vrliADPassword: l10n('appConstants.fieldMapping.vrliADPassword'),
  vrliADConnectionType: l10n('appConstants.fieldMapping.vrliADConnectionType'),
  vrliIsSSLOnly: l10n('appConstants.fieldMapping.vrliIsSSLOnly'),
  vropsStorage: l10n('appConstants.fieldMapping.vropsStorage'),
  useIso: l10n('appConstants.fieldMapping.useIso'),
  useMasterIdentityManager: l10n(
    'appConstants.fieldMapping.useMasterIdentityManager'
  ),
  useWindowsAuthentication: l10n(
    'appConstants.fieldMapping.useWindowsAuthentication'
  ),
  useWindowsTemplate: l10n('appConstants.fieldMapping.useWindowsTemplate'),
  vcenterInfra: l10n('appConstants.fieldMapping.vcenterInfra'),
  vCenterHost: l10n('appConstants.fieldMapping.vCenterHost'),
  vCenterList: l10n('appConstants.fieldMapping.vCenterList'),
  vCenterName: l10n('appConstants.fieldMapping.vCenterName'),
  vcHostname: l10n('appConstants.fieldMapping.vcHostname'),
  vCenterHostForAuthentication: l10n(
    'appConstants.fieldMapping.vCenterHostForAuthentication'
  ),
  vcPassword: l10n('appConstants.fieldMapping.vcPassword'),
  vcUsername: l10n('appConstants.fieldMapping.vcUsername'),
  vmwareSSOEnabled: l10n('appConstants.fieldMapping.vidbEnabled'),
  group: l10n('appConstants.fieldMapping.vidbUserGroup'),
  vidmAdBaseDN: l10n('appConstants.fieldMapping.vidmAdBaseDN'),
  vidmAdBindDN: l10n('appConstants.fieldMapping.vidmAdBindDN'),
  vidmAdBindPassword: l10n('appConstants.fieldMapping.vidmAdBindPassword'),
  vidmAdGroupDN: l10n('appConstants.fieldMapping.vidmAdGroupDN'),
  vidmAdminPassword: l10n('appConstants.fieldMapping.vidmAdminPassword'),
  vidmAdName: l10n('appConstants.fieldMapping.vidmAdName'),
  vidmAdUserDN: l10n('appConstants.fieldMapping.vidmAdUserDN'),
  vidmConnectorName: l10n('appConstants.fieldMapping.vidmConnectorName'),
  vidmConnectorAdminPassword: l10n(
    'appConstants.fieldMapping.vidmConnectorAdminPassword'
  ),
  vidmLBRootCertificateChain: l10n(
    'appConstants.fieldMapping.vidmLBRootCertificateChain'
  ),
  vidmPassword: l10n('appConstants.fieldMapping.vidmPassword'),
  vidmRootPassword: l10n('appConstants.fieldMapping.vidmRootPassword'),
  vidmSshPassword: l10n('appConstants.fieldMapping.vidmSshPassword'),
  vidmSystemAdminPassword: l10n(
    'appConstants.fieldMapping.vidmSystemAdminPassword'
  ),
  vmName: l10n('appConstants.fieldMapping.vmName'),
  vmNetwork: l10n('appConstants.fieldMapping.vmNetwork'),
  vmPassword: l10n('appConstants.fieldMapping.vmPassword'),
  vra_7_0_0_0_vra_default_property: l10n(
    'appConstants.fieldMapping.vra_7_0_0_0_vra_default_property'
  ),
  vra_8_0_0_password: l10n('appConstants.fieldMapping.vra_8_0_0_password'),
  vraAdminPassword: l10n('appConstants.fieldMapping.vraAdminPassword'),
  vratenantUser: l10n('appConstants.fieldMapping.vratenantUser'),
  vraDb: l10n('appConstants.fieldMapping.vraDb'),
  vraImportVersion: l10n('appConstants.fieldMapping.vraImportVersion'),
  vraPrimaryHostname: l10n('appConstants.fieldMapping.vraPrimaryHostname'),
  vraPrimaryRootPassword: l10n(
    'appConstants.fieldMapping.vraPrimaryRootPassword'
  ),
  vraK8ClusterCidr: l10n('appConstants.fieldMapping.vraK8ClusterCidr'),
  vraK8ServiceCidr: l10n('appConstants.fieldMapping.vraK8ServiceCidr'),
  vrb_default_property: l10n('appConstants.fieldMapping.vrb_default_property'),
  vrbAuthType: l10n('appConstants.fieldMapping.vrbAuthType'),
  vrbCafeHost: l10n('appConstants.fieldMapping.vrbCafeHost'),
  vrbCafeSsoAdminUser: l10n('appConstants.fieldMapping.vrbCafeSsoAdminUser'),
  vrbCafeSsoPassword: l10n('appConstants.fieldMapping.vrbCafeSsoPassword'),
  vrbCafeSsoTenant: l10n('appConstants.fieldMapping.vrbCafeSsoTenant'),
  vrbCurrency: l10n('appConstants.fieldMapping.vrbCurrency'),
  vrbDefault: l10n('appConstants.fieldMapping.vrbDefault'),
  vrbHostName: l10n('appConstants.fieldMapping.vrbHostName'),
  vrbLicenseKey: l10n('appConstants.fieldMapping.vrbLicenseKey'),
  vrbRootPassword: l10n('appConstants.fieldMapping.vrbRootPassword'),
  vrbTelemetryEnabled: l10n('appConstants.fieldMapping.vrbTelemetryEnabled'),
  vrbVidmAdminPassword: l10n('appConstants.fieldMapping.vrbVidmAdminPassword'),
  vrbVidmAdminUserName: l10n('appConstants.fieldMapping.vrbVidmAdminUserName'),
  vrbVidmHostName: l10n('appConstants.fieldMapping.vrbVidmHostName'),
  vrli_default_property: l10n(
    'appConstants.fieldMapping.vrli_default_property'
  ),
  vrliAdminEmail: l10n('appConstants.fieldMapping.vrliAdminEmail'),
  vrliAdminPassword: l10n('appConstants.fieldMapping.vrliAdminPassword'),
  vrliAdminUser: l10n('appConstants.fieldMapping.vrliAdminUser'),
  vrliClusterVips: l10n('appConstants.fieldMapping.vrliClusterVips'),
  vrliHostName: l10n('appConstants.fieldMapping.vrliHostName'),
  vrliLicenseKey: l10n('appConstants.fieldMapping.vrliLicenseKey'),
  vrliRootPassword: l10n('appConstants.fieldMapping.vrliRootPassword'),
  vrniLicense: l10n('appConstants.fieldMapping.vrniLicense'),
  vrniNodeSize: l10n('appConstants.fieldMapping.vrniNodeSize'),
  vrniPlatformUserName: l10n('appConstants.fieldMapping.vrniPlatformUserName'),
  vrniPlatformPassword: l10n('appConstants.fieldMapping.vrniPlatformPassword'),
  vrops_master_default_property: l10n(
    'appConstants.fieldMapping.vrops_master_default_property'
  ),
  vropsAdminPassword: l10n('appConstants.fieldMapping.vropsAdminPassword'),
  vropsDataDefault: l10n('appConstants.fieldMapping.vropsDataDefault'),
  vropsDataInfra: l10n('appConstants.fieldMapping.vropsDataInfra'),
  vropsMasterNodeIP: l10n('appConstants.fieldMapping.vropsMasterNodeIP'),
  vsphereEndpointName: l10n('appConstants.fieldMapping.vsphereEndpointName'),
  webCertificate: l10n('appConstants.fieldMapping.webCertificate'),
  webPassword: l10n('appConstants.fieldMapping.webPassword'),
  webUserName: l10n('appConstants.fieldMapping.webUserName'),
  windowsAdminPassword: l10n('appConstants.fieldMapping.windowsAdminPassword'),
  windowsDeployType: l10n('appConstants.fieldMapping.windowsDeployType'),
  windowsIaas: l10n('appConstants.fieldMapping.windowsIaas'),
  windowsLocalPassword: l10n('appConstants.fieldMapping.windowsLocalPassword'),
  windowsLocalUserName: l10n('appConstants.fieldMapping.windowsLocalUserName'),
  windowsOs: l10n('appConstants.fieldMapping.windowsOs'),
  windowsPassword: l10n('appConstants.fieldMapping.windowsPassword'),
  windowsUserName: l10n('appConstants.fieldMapping.windowsUserName'),
  windowsVMName: l10n('appConstants.fieldMapping.windowsVMName'),
  zoneName: l10n('appConstants.fieldMapping.zoneName'),
  productId: l10n('appConstants.fieldMapping.productId'),
  productVersion: l10n('appConstants.fieldMapping.productVersion'),
  repositoryType: l10n('appConstants.fieldMapping.repositoryType'),
  repositoryUrl: l10n('appConstants.fieldMapping.repositoryUrl'),
  proxyIP: l10n('appConstants.fieldMapping.proxyIP'),
  accessKey: l10n('appConstants.fieldMapping.accessKey'),
  secretKey: l10n('appConstants.fieldMapping.secretKey'),
  dsEnableFlows: l10n('appConstants.fieldMapping.dsEnableFlows'),
  dsNickname: l10n('appConstants.fieldMapping.dsNickname'),
  dsNotes: l10n('appConstants.fieldMapping.dsNotes'),
  dsAzureTenant: l10n('appConstants.fieldMapping.dsAzureTenant'),
  dsAzureClient: l10n('appConstants.fieldMapping.dsAzureClient'),
  dsAzureKey: l10n('appConstants.fieldMapping.dsAzureKey'),
  dsAzureSubsciption: l10n('appConstants.fieldMapping.dsAzureSubsciption'),
  dsIp: l10n('appConstants.fieldMapping.dsIp'),
  dsUsername: l10n('appConstants.fieldMapping.dsUsername'),
  dsPassword: l10n('appConstants.fieldMapping.dsPassword'),
  snmpEnabled: l10n('appConstants.fieldMapping.snmpEnabled'),
  snmpSelected: l10n('appConstants.fieldMapping.snmpSelected'),
  configFileLocation: l10n('appConstants.fieldMapping.configFileLocation'),
  dsManagerIp: l10n('appConstants.fieldMapping.dsManagerIp'),
  kubeconfig: l10n('appConstants.fieldMapping.kubeconfig'),
  vCenterIp: l10n('appConstants.fieldMapping.vCenterIp'),
  refreshToken: l10n('appConstants.fieldMapping.refreshToken'),
  dfwIpfix: l10n('appConstants.fieldMapping.dfwIpfix'),
  dsInstanceId: l10n('appConstants.fieldMapping.dsInstanceId'),
  dsGraphConfig: l10n('appConstants.fieldMapping.dsGraphConfig'),
  isDsGraphConfigCustomized: l10n(
    'appConstants.fieldMapping.isDsGraphConfigCustomized'
  ),
  switchType: l10n('appConstants.fieldMapping.switchType'),
  dvSwitchList: l10n('appConstants.fieldMapping.dvSwitchList'),
  kbUrl: l10n('appConstants.fieldMapping.kbUrl'),
  isLBSslTerminated: l10n('appConstants.fieldMapping.isLBSslTerminated'),
  fipsEnabled: l10n('appConstants.fieldMapping.fipsEnabled'),
  fipsMode: l10n('appConstants.fieldMapping.fipsMode'),
  vidmDomainName: l10n('appConstants.fieldMapping.vidmDomainName'),
  vidmDBType: l10n('appConstants.fieldMapping.vidmDBType'),
  isClustered: l10n('appConstants.fieldMapping.isClustered'),
  windowsDeployement: l10n('appConstants.fieldMapping.windowsDeployement'),
  vidmAdminUser: l10n('appConstants.fieldMapping.vidmAdminUser', [
    PRODUCT_NAME_CONSTANTS.vidm
  ]),
  vidmHost: l10n('appConstants.fieldMapping.vidmHost', [
    PRODUCT_NAME_CONSTANTS.vidm
  ]),
  vsscHostName: l10n('appConstants.fieldMapping.vsscHostName'),
  vrasscAdminPassword: l10n('appConstants.fieldMapping.vrasscAdminPassword', [
    PRODUCT_SHORT.vssc
  ]),
  vrasscRootAdminPassword: l10n(
    'appConstants.fieldMapping.vrasscRootAdminPassword'
  ),
  defaultTenantAlias: l10n('appConstants.fieldMapping.defaultTenantAlias'),
  domainJoined: l10n('appConstants.fieldMapping.domainJoined'),
  canBeDeleted: l10n('appConstants.fieldMapping.canBeDeleted'),
  masterTenantId: l10n('appConstants.fieldMapping.masterTenantId'),
  vsscRootAdminPassword: l10n(
    'appConstants.fieldMapping.vsscRootAdminPassword'
  ),
  vsscRootPassword: l10n('appConstants.fieldMapping.vsscRootPassword'),
  tenantId: l10n('appConstants.fieldMapping.tenantId'),
  proxyName: l10n('appConstants.fieldMapping.proxyName'),
  cloudProxyServiceType: l10n(
    'appConstants.fieldMapping.cloudProxyServiceType'
  ),
  cloudProxyCspServer: l10n('appConstants.fieldMapping.cloudProxyCspServer'),
  cloudProxyCspApiServer: l10n(
    'appConstants.fieldMapping.cloudProxyCspApiServer'
  ),
  cloudProxyRefreshKey: l10n('appConstants.fieldMapping.cloudProxyRefreshKey'),
  contentLibraryItemId: l10n('appConstants.fieldMapping.contentLibraryItemId'),
  cloudProxyRefreshToken: l10n(
    'appConstants.fieldMapping.cloudProxyRefreshKey'
  ),
  cloudProxyIP: l10n('appConstants.fieldMapping.cloudProxyIP'),
  cloudProxyPassword: l10n('appConstants.fieldMapping.cloudProxyPassword'),
  cloudProxyServiceTypeCloudAssembly: l10n(
    'appConstants.fieldMapping.cloudProxyServiceTypeCloudAssembly'
  ),
  cloudProxyServiceTypeLogInsight: l10n(
    'appConstants.fieldMapping.cloudProxyServiceTypeLogInsight'
  ),
  cloudProxyServiceTypevRCSM: l10n(
    'appConstants.fieldMapping.cloudProxyServiceTypevRCSM'
  ),
  enablePendoSetting: l10n('appConstants.fieldMapping.enablePendoSetting'),
  vraTenantHost: l10n('appConstants.fieldHelpTextMapping.vraTenantHost'),
  vraTenantHostName: l10n(
    'appConstants.fieldHelpTextMapping.vraTenantHostName'
  ),
  vroAdminPassword: l10n('appConstants.fieldHelpTextMapping.vroAdminPassword'),
  vroHostName: l10n('appConstants.fieldHelpTextMapping.vroHostName'),
  vidmTenantAdmin: l10n('appConstants.fieldHelpTextMapping.vidmTenantAdmin'),
  vidmTenantAdminPassword: l10n(
    'appConstants.fieldHelpTextMapping.vidmTenantAdminPassword'
  ),
  vrliLogForwardingConfiguration: l10n(
    'lcops.environment.actions.vrliLogForwardingConfig'
  ),
  vropsLogEntities: l10n('lcops.environment.actions.vropsLogEntities'),
  monitorWithvROps: l10n('lcops.environment.actions.monitorWithVrops'),
  integrateWithSddcManager: l10n(
    'lcops.environment.actions.integrateWithSddcManager'
  ),
  sddcManagerHostname: l10n('lcops.environment.actions.sddcManagerHostname'),
  sddcManagerUsername: l10n('lcops.environment.actions.sddcManagerUsername'),
  sddcManagerPassword: l10n('lcops.environment.actions.sddcManagerPassword'),
  installSddcManagementPack: l10n(
    'lcops.environment.actions.installSddcManagementPack'
  ),
  forceIpV6: l10n('lcops.environment.actions.forceIpV6'),
  configureManagementPack: l10n(
    'lcops.environment.actions.configureManagementPack'
  ),
  vROpsEnvironmentId: l10n('lcops.environment.actions.vROpsEnvironmentId'),
  takeProductSnapshot: l10n('appConstants.fieldMapping.takeProductSnapshot'),
  autoRevert: l10n('appConstants.fieldMapping.autoRevert'),
  retainProductSnapshot: l10n(
    'appConstants.fieldMapping.retainProductSnapshot'
  ),
  skipTask: l10n('appConstants.fieldMapping.skipTask')
};

export const FIELD_VMID_MAPPING = {
  adminEmail_vrli_import: 'Operations for Logs Admin Email'
};

export const NODE_FIELD_MAPPING = {
  'windows-box:fullName': 'Full Name'
};

export const FIELD_PLACEHOLDER_MAPPING = {
  vmName: l10n('appConstants.fieldPlaceholderMapping.vmName'),
  ip: l10n('appConstants.fieldPlaceholderMapping.ip'),
  ipv6: l10n('appConstants.fieldPlaceholderMapping.ipv6'),
  hostName: l10n('appConstants.fieldPlaceholderMapping.hostName'),
  vidmAdName: l10n('appConstants.fieldPlaceholderMapping.vidmAdName'),
  uberAdmin: l10n('appConstants.fieldPlaceholderMapping.uberAdmin'),
  adminEmail: l10n('appConstants.fieldPlaceholderMapping.adminEmail'),
  adminUserName: l10n('appConstants.fieldPlaceholderMapping.adminUserName'),
  dbInstance: l10n('appConstants.fieldPlaceholderMapping.dbInstance'),
  defaultConfigurationEmail: l10n(
    'appConstants.fieldPlaceholderMapping.defaultConfigurationEmail'
  ),
  defaultConfigurationUsername: l10n(
    'appConstants.fieldPlaceholderMapping.defaultConfigurationUsername'
  ),
  domainAdmin: l10n('appConstants.fieldPlaceholderMapping.domainAdmin'),
  extendHardDiskCapacity: l10n(
    'appConstants.fieldPlaceholderMapping.extendHardDiskCapacity'
  ),
  portNumber: l10n('appConstants.fieldPlaceholderMapping.portNumber'),
  vidmAdBindDN: l10n('appConstants.fieldPlaceholderMapping.vidmAdBindDN'),
  vidmAdBaseDN: l10n('appConstants.fieldPlaceholderMapping.vidmAdBaseDN'),
  vidmAdGroupDN: l10n('appConstants.fieldPlaceholderMapping.vidmAdGroupDN'),
  vidmAdUserDN: l10n('appConstants.fieldPlaceholderMapping.vidmAdUserDN'),
  vidmConnectorName: l10n(
    'appConstants.fieldPlaceholderMapping.vidmConnectorName'
  ),
  vrliHostName: l10n('appConstants.fieldPlaceholderMapping.vrliHostName', [
    PRODUCT_NAME_CONSTANTS.vrli
  ]),
  vrliDataInterval: l10n(
    'appConstants.fieldPlaceholderMapping.vrliDataInterval'
  ),
  vrliSMTPDefaultSenderEmail: l10n(
    'appConstants.fieldPlaceholderMapping.vrliSMTPDefaultSenderEmail'
  ),
  vrliSMTPLogin: l10n('appConstants.fieldPlaceholderMapping.vrliSMTPLogin'),
  vrliSMTPPassword: l10n(
    'appConstants.fieldPlaceholderMapping.vrliSMTPPassword'
  ),
  vrliSMTPPort: l10n('appConstants.fieldPlaceholderMapping.vrliSMTPPort'),
  vrliSMTPServer: l10n('appConstants.fieldPlaceholderMapping.vrliSMTPServer'),
  vrliADDomain: l10n('appConstants.fieldPlaceholderMapping.vrliADDomain'),
  vrliADDomainControllers: l10n(
    'appConstants.fieldPlaceholderMapping.vrliADDomainControllers'
  ),
  vrliADUsername: l10n('appConstants.fieldPlaceholderMapping.vrliADUsername'),
  vrliADPassword: l10n('appConstants.fieldPlaceholderMapping.vrliADPassword'),
  vrliADConnectionType: l10n(
    'appConstants.fieldPlaceholderMapping.vrliADConnectionType'
  ),
  vrliIsSSLOnly: l10n('appConstants.fieldPlaceholderMapping.vrliIsSSLOnly'),
  vrliADPort: l10n('appConstants.fieldPlaceholderMapping.vrliADPort'),
  vsphereEndpointName: l10n(
    'appConstants.fieldPlaceholderMapping.vsphereEndpointName'
  )
};

export const FIELD_VMID_HELP_TEXT_MAPPING = {
  hostName_import_vidm: l10n(
    'appConstants.fieldVMIDHelpTextMapping.hostName_import_vidm'
  )
};

export const FIELD_HELP_TEXT_MAPPING = {
  adminEmail: l10n('appConstants.fieldHelpTextMapping.adminEmail'),
  vraK8ClusterCidr: l10n('appConstants.fieldHelpTextMapping.vraK8ClusterCidr'),
  vraK8ServiceCidr: l10n('appConstants.fieldHelpTextMapping.vraK8ServiceCidr'),
  configureAffinitySeparateAll: l10n(
    'appConstants.fieldHelpTextMapping.configureAffinitySeparateAll'
  ),
  isUpgradeVmCompatibility: l10n(
    'appConstants.fieldHelpTextMapping.isUpgradeVmCompatibility'
  ),
  vrliAlwaysUseEnglish: l10n(
    'appConstants.fieldHelpTextMapping.vrliAlwaysUseEnglish'
  ),
  defaultPassword: l10n('appConstants.fieldHelpTextMapping.defaultPassword'),
  extendedStorage: l10n('appConstants.fieldHelpTextMapping.extendedStorage'),
  fipsMode: l10n('appConstants.fieldHelpTextMapping.fipsMode'),
  uberAdmin: l10n('appConstants.fieldHelpTextMapping.uberAdmin'),
  vidmAdminPassword: l10n(
    'appConstants.fieldHelpTextMapping.vidmAdminPassword'
  ),
  vidmAdBaseDN: l10n('appConstants.fieldHelpTextMapping.vidmAdBaseDN'),
  vidmAdBindDN: l10n('appConstants.fieldHelpTextMapping.vidmAdBindDN'),
  vidmAdGroupDN: l10n('appConstants.fieldHelpTextMapping.vidmAdGroupDN'),
  vidmAdUserDN: l10n('appConstants.fieldHelpTextMapping.vidmAdUserDN'),
  'vidm-delegate:ip': l10n(
    'appConstants.fieldHelpTextMapping.vidm-delegate:ip'
  ),
  certificateAlias: l10n('appConstants.fieldHelpTextMapping.certificateAlias'),
  registervROpswithvRA: l10n(
    'appConstants.fieldHelpTextMapping.registervROpswithvRA'
  ),
  defaultConfigurationEmail: l10n(
    'appConstants.fieldHelpTextMapping.defaultConfigurationEmail'
  ),
  defaultConfigurationUsername: l10n(
    'appConstants.fieldHelpTextMapping.defaultConfigurationUsername'
  ),
  syncGroupMembers: l10n('appConstants.fieldHelpTextMapping.syncGroupMembers', [
    PRODUCT_NAME_CONSTANTS.lcm,
    PRODUCT_NAME_CONSTANTS.vidm
  ]),
  vrliSMTPDefaultSenderEmail: l10n(
    'appConstants.fieldHelpTextMapping.vrliSMTPDefaultSenderEmail'
  ),
  vrliADDomain: l10n('appConstants.fieldHelpTextMapping.vrliADDomain'),
  vrliADDomainControllers: l10n(
    'appConstants.fieldHelpTextMapping.vrliADDomainControllers'
  ),
  vrliADUsername: l10n('appConstants.fieldHelpTextMapping.vrliADUsername'),
  vrliADConnectionType: l10n(
    'appConstants.fieldHelpTextMapping.vrliADConnectionType'
  ),
  vsphereEndpointName: l10n(
    'appConstants.fieldHelpTextMapping.vsphereEndpointName'
  ),
  isLBSslTerminated: l10n(
    'appConstants.fieldHelpTextMapping.isLBSslTerminated'
  ),
  tenantId: l10n('appConstants.fieldHelpTextMapping.tenantId', [
    PRODUCT_NAME_CONSTANTS.vra,
    PRODUCT_NAME_CONSTANTS.vssc
  ]),
  vroTenantId:
    l10n('appConstants.fieldHelpTextMapping.tenantId', [
      PRODUCT_NAME_CONSTANTS.vra,
      PRODUCT_NAME_CONSTANTS.vro
    ]) +
    ' ' +
    l10n('appConstants.fieldHelpTextMapping.vroTenatIdInfo'),
  vraImportVersion: l10n('appConstants.fieldHelpTextMapping.vraImportVersion', [
    PRODUCT_NAME_CONSTANTS.vra,
    PRODUCT_NAME_CONSTANTS.vssc
  ]),
  masterVidmEnabledVssc: l10n(
    'appConstants.fieldHelpTextMapping.masterVidmEnabledVssc',
    [PRODUCT_NAME_CONSTANTS.vssc, PRODUCT_NAME_CONSTANTS.vra]
  ),
  vidmSystemAdminPassword: l10n(
    'appConstants.fieldHelpTextMapping.vidmSystemAdminPassword'
  ),
  port: l10n('appConstants.fieldHelpTextMapping.port'),
  instanceId: l10n('appConstants.fieldHelpTextMapping.instanceId'),
  version: l10n('appConstants.fieldHelpTextMapping.version')
};

export const FIELD_DISPLAY_ORDER = ['username', 'password'];

export function fieldComparator(a: string, b: string) {
  const aIndex = FIELD_DISPLAY_ORDER.indexOf(a);
  const bIndex = FIELD_DISPLAY_ORDER.indexOf(b);

  return (
    (aIndex === -1 ? Number.MAX_VALUE : aIndex) -
    (bIndex === -1 ? Number.MAX_VALUE : bIndex)
  );
}

// Remove forceIpV6 from the EXCLUDE_PRODUCT_PROPERTIES when vrops support ipv6.
export const EXCLUDE_PRODUCT_PROPERTIES = [
  'isImport',
  'licenseRef',
  'vraK8ClusterCidr',
  'vraK8ServiceCidr',
  'snapshot:takeSnapshot',
  'snapshot:isRetainSnapshot',
  'integrateWithSddcManager',
  'sddcManagerHostname',
  'sddcManagerUsername',
  'sddcManagerPassword',
  'forceIpV6'
];

export const EXCLUDE_PRODUCT_PROPERTIES_FOR_DISPLAY = [
  'adminEmail',
  'license',
  'isImport',
  'licenseRef',
  'supportPassword',
  'consolePassword',
  'adapterFiles',
  'networkProxySettings',
  'userType'
];

export const TEXTAREA_PROPERTIES = [
  'certificate',
  'privateKey',
  'certificateChain'
];

export const CHECKBOX_PROPERTIES = ['isStandalone'];

export const CERTIFICATE_PROPERTIES = [
  'certificate',
  'cafeCertificate',
  'msCertificate',
  'webCertificate'
];

export const PASSWORD_PROPERTIES = [
  'destinationPassword',
  'password',
  'cafeRootPasswordPrimary',
  'consolePassword',
  'databasePassword',
  'defaultConfigurationPassword',
  'defaultPassword',
  'rootPassword',
  'supportPassword',
  'tenantUserPassword',
  'vcPassword',
  'vidmAdBindPassword',
  'vidmAdminPassword',
  'vidmRootPassword',
  'vidmSshPassword',
  'vidmSystemAdminPassword',
  'vraAdminPassword',
  'vrbCafeSsoPassword',
  'vrbRootPassword',
  'vrbVidmAdminPassword',
  'vrliAdminPassword',
  'vrliRootPassword',
  'vrniPlatformPassword',
  'vropsAdminPassword',
  'vropsRootPassword',
  'windowsPassword',
  'defaultConfigurationPassword',
  'productPassword',
  'dsPassword',
  'vraPrimaryRootPassword',
  'masterVidmAdminPassword',
  'vidmConnectorAdminPassword',
  'domainAdminPassword',
  'vsscRootAdminPassword',
  'vsscRootPassword',
  'vrasscAdminPassword',
  'cloudProxyRefreshToken',
  'vidmTenantAdminPassword',
  'vroAdminPassword',
  'encryptionPassword'
];

export const MASKED_PROPERTIES = [
  'certificateChain',
  'msCertificateChain',
  'webCertificateChain',
  'cafeCertificateChain',
  'keyPassphrase',
  'privateKey',
  'vidmOAuthServiceClientId',
  'vidmOAuthServiceClientSecret'
];

export const LOCKER_PROPERTIES = [
  ...CERTIFICATE_PROPERTIES,
  ...PASSWORD_PROPERTIES
];

export const INFRA_DEFAULT_PROPERTIES = [
  'vCenterHost',
  'vCenterName',
  'vcUsername',
  'vcPassword',
  'cluster',
  'storage',
  'network',
  'diskMode',
  'folderName',
  'resourcePool',
  'masterVidmEnabled',
  'vmwareSSOEnabled',
  'vmwareSSOConfig',
  'vCenterHostname',
  '_leverageProximity'
];

export const NETWORK_DEFAULT_PROPERTIES = [
  'gateway',
  'domain',
  'searchpath',
  'dns',
  'netmask',
  'ntp',
  'ipv6Gateway',
  'ipv6Netmask',
  'useIpv4',
  'useIpv6',
  'useIpv4AndIpv6'
];

/**
 * Properties which are not displayed on UI (both key & val)
 */
export const HIDDEN_PROPERTIES = ['acceptEULA', ...MASKED_PROPERTIES];

const clusterNameValueUpdater = (value: string) => {
  if (value) {
    return value.split('#').pop() || value;
  }
  return '-';
};

const dnsServersValueUpdater = (value: string) => {
  if (value) {
    return value.split(',').join(', ') || value;
  }
  return '-';
};

export interface FieldGroup {
  name: string;
  properties: FieldGroupProperty[];
}

interface FieldGroupProperty {
  name: string;
  icon?: string;
  valueUpdater?: (value: string) => string | JSX.Element;
}

export const FIELD_GROUPS: FieldGroup[] = [
  {
    name: l10n('appConstants.fieldGroups.vmDetails'),
    properties: [
      {
        name: 'vmName',
        icon: 'vm'
      },
      {
        name: 'hostName'
      },
      {
        name: 'ip'
      },
      {
        name: 'ipv6'
      }
    ]
  },
  {
    name: l10n('dataCenterCaps'),
    properties: [
      {
        name: 'dataCenterVmid',
        icon: 'building'
      }
    ]
  },
  {
    name: l10n('infrastructure'),
    properties: [
      {
        name: 'vCenterHost',
        icon: 'host'
      },
      {
        name: 'cluster',
        valueUpdater: clusterNameValueUpdater,
        icon: 'cluster'
      },
      {
        name: 'network',
        icon: 'cloud-network'
      },
      {
        name: 'storage',
        icon: 'data-cluster'
      },
      {
        name: 'diskMode',
        icon: 'hard-disk'
      },
      {
        name: 'folderName',
        icon: 'folder'
      },
      {
        name: 'resourcePool',
        icon: 'resource-pool'
      },
      {
        name: 'vCenterName'
      },
      {
        name: 'vcUsername'
      },
      {
        name: 'vcPassword'
      }
    ]
  },
  {
    name: l10n('network'),
    properties: [
      {
        name: 'gateway'
      },
      {
        name: 'ipv6Gateway'
      },
      {
        name: 'domain'
      },
      {
        name: 'searchpath'
      },
      {
        name: 'dns',
        valueUpdater: dnsServersValueUpdater
      },
      {
        name: 'netmask'
      },
      {
        name: 'ipv6Netmask'
      },
      {
        name: 'ntp'
      },
      {
        name: 'useIpv4AndIpv6'
      }
    ]
  }
];

export const FIELD_GROUPS_PROPS = FIELD_GROUPS.reduce(
  (acc: string[], cur) => {
    return [...acc, ...cur.properties.map(p => p.name)];
  },
  ['license', 'regionName', 'zoneName']
);

export const HIDDEN_OTHER_PROPS = [
  'disabled',
  'vrniLicense',
  'certificateVmid',
  'isDhcp',
  'adminEmail',
  'vcfProperties',
  'certificate',
  'vmwareSSOConfig',
  'vmwareSSOEnabled',
  'Domain',
  'vCenterHostname'
];

export const VRLI_JNJ_NODES = [
  'retentionThreasold',
  'configureActiveDirectory',
  'logInsightForwarding',
  'vrliVsphereEndPointsDetails',
  'vrliAdditionalDisk',
  'smtpConfiguration'
];

export const WORKFLOW_NODE_TYPES_MAPPING = {
  ...NODE_TYPES_MAPPING,
  'vidm-connector': 'Windows Connector'
};

export const FAILIURE_STATES = [
  'FAILED',
  'PRE_VALIDATION_FAILED',
  'CANCELLED',
  'Failed'
];
export const WARNING_STATES = ['WARNING', 'Warning'];

export const PRODUCT_MAPPING = PRODUCT_NAME_CONSTANTS;

export const COMPONENT_MAPPING = {
  vra: l10n('appConstants.componentMapping.cafeComponent'),
  'iaas-web': l10n('appConstants.componentMapping.iaasWebComponent'),
  'iaas-ms': l10n('appConstants.componentMapping.iaasManagerComponent')
};
export const VRA_COMPONENTS = ['vra', 'iaas-web', 'iaas-ms'];

export const TOTAL_STEPS = {
  regular: 10,
  vidm: 9
};

export const REQUEST_MAPPING = {
  adapterOperation: l10n('appConstants.requestMapping.adapterOperation'),
  addadoverldap: l10n('appConstants.requestMapping.addadoverldap'),
  adddatasource: l10n('appConstants.requestMapping.adddatasource'),
  addnodeenvironmentvalidation: l10n(
    'appConstants.requestMapping.addnodeenvironmentvalidation'
  ),
  addproduct: l10n('appConstants.requestMapping.addproduct'),
  addproductenvironmentvalidation: l10n(
    'appConstants.requestMapping.addproductenvironmentvalidation'
  ),
  addvidmad: l10n('appConstants.requestMapping.addvidmad'),
  'audit#certificate': l10n('appConstants.requestMapping.audit#certificate'),
  'audit#password': l10n('appConstants.requestMapping.audit#password'),
  assigntenantadmin: l10n('appConstants.requestMapping.assigntenantadmin'),
  blackstonecontent: l10n('appConstants.requestMapping.blackstonecontent'),
  changentpconfig: l10n('appConstants.requestMapping.changentpconfig'),
  cloudmarketplacecontentdownload: l10n(
    'appConstants.requestMapping.cloudmarketplacecontentdownload'
  ),
  configurevROPSAsWLPEndpoint: l10n(
    'appConstants.requestMapping.configurevROPSAsWLPEndpoint'
  ),
  configureVIDB: l10n('appConstants.requestMapping.configureVIDB'),
  createenvironment: l10n('appConstants.requestMapping.createenvironment'),
  createenvironmentvalidation: l10n(
    'appConstants.requestMapping.createenvironmentvalidation'
  ),
  createenvironmentwithprevaldation: l10n(
    'appConstants.requestMapping.createenvironmentwithprevaldation'
  ),
  createlocaluser: l10n('appConstants.requestMapping.createlocaluser'),
  cspConnectivityCheck: l10n(
    'appConstants.requestMapping.cspConnectivityCheck'
  ),
  deletedatacenter: l10n('lcops.dataCenters.deleteDataCenter'),
  deleteEnvironment: l10n('appConstants.requestMapping.deleteEnvironment'),
  deleteMarketplaceApp: l10n(
    'appConstants.requestMapping.deleteMarketplaceApp'
  ),
  deletepatchbinary: l10n('appConstants.requestMapping.deletepatchbinary'),
  deleteproduct: l10n('appConstants.requestMapping.deleteproduct'),
  deleteproductbinary: l10n('appConstants.requestMapping.deleteproductbinary'),
  deleteproductsnapshot: l10n(
    'appConstants.requestMapping.deleteproductsnapshot'
  ),
  deletetenant: l10n('appConstants.requestMapping.deletetenant'),
  deletevcenter: l10n('lcops.dataCenters.deleteVCenter'),
  enablemultitenancy: l10n('appConstants.requestMapping.enablemultitenancy'),
  environmentHealth: l10n('appConstants.requestMapping.environmentHealth'),
  environmenthealthschedule: l10n(
    'appConstants.requestMapping.environmenthealthschedule'
  ),
  environmentLogs: l10n('appConstants.requestMapping.environmentLogs'),
  fetchalltenantadmins: l10n(
    'appConstants.requestMapping.fetchalltenantadmins'
  ),
  fetchalltenants: l10n('appConstants.requestMapping.fetchalltenants'),
  fetchtenantlist: l10n('appConstants.requestMapping.fetchtenantlist'),
  getallconnectors: l10n('appConstants.requestMapping.getallconnectors'),
  getdirectorydetails: l10n('appConstants.requestMapping.getdirectorydetails'),
  getdirectorysyncexecs: l10n(
    'appConstants.requestMapping.getdirectorysyncexecs'
  ),
  getdirsyncexecalerts: l10n(
    'appConstants.requestMapping.getdirsyncexecalerts'
  ),
  getvidmuserattrdefinitions: l10n(
    'appConstants.requestMapping.getvidmuserattrdefinitions'
  ),
  gracefulshutdown: l10n('appConstants.requestMapping.gracefulshutdown'),
  grainsconfiguration: l10n('appConstants.requestMapping.grainsconfiguration'),
  installandconfiguresddcadapter: l10n(
    'appConstants.requestMapping.installandconfiguresddcadapter'
  ),
  installcp: l10n('appConstants.requestMapping.installcp'),
  installmp: l10n('appConstants.requestMapping.installmp'),
  installsaltminion: l10n('appConstants.requestMapping.installsaltminion'),
  invokemigration: l10n('appConstants.requestMapping.invokemigration'),
  lcmgenricsetting: l10n('appConstants.requestMapping.lcmgenricsetting'),
  lcmpatchsetting: l10n('appConstants.requestMapping.lcmpatchsetting'),
  lcmpspacksetting: l10n('appConstants.requestMapping.lcmpspacksetting'),
  lcmsupportbundle: l10n('appConstants.requestMapping.lcmsupportbundle'),
  lcmvadiskexpand: l10n('appConstants.requestMapping.lcmvadiskexpand'),
  licenseTermination: l10n('appConstants.requestMapping.licenseTermination'),
  licenseUsage: l10n('appConstants.requestMapping.licenseUsage'),
  licenseusagechedules: l10n(
    'appConstants.requestMapping.licenseusagechedules'
  ),
  licenseusagefetch: l10n('appConstants.requestMapping.licenseusagefetch'),
  licenseusageperiodic: l10n(
    'appConstants.requestMapping.licenseusageperiodic'
  ),
  masterconfiguration: l10n('appConstants.requestMapping.masterconfiguration'),
  marketplaceappdownload: l10n(
    'appConstants.requestMapping.marketplaceappdownload'
  ),
  marketplaceapps: l10n('appConstants.requestMapping.marketplaceapps'),
  marketplaceeula: l10n('appConstants.requestMapping.marketplaceeula'),
  monitorvRA: l10n('appConstants.requestMapping.monitorvRA'),
  myvmwaredownload: l10n('appConstants.requestMapping.myvmwaredownload'),
  myvmwaredownloadlicenses: l10n(
    'appConstants.requestMapping.myvmwaredownloadlicenses'
  ),
  myvmwarelicenseschedules: l10n(
    'appConstants.requestMapping.myvmwarelicenseschedules'
  ),
  myvmwarerefreshlicenses: l10n(
    'appConstants.requestMapping.myvmwarerefreshlicenses'
  ),
  myvmwarevalidate: l10n('appConstants.requestMapping.myvmwarevalidate'),
  offlinepatchovasetting: l10n(
    'appConstants.requestMapping.offlinepatchovasetting'
  ),
  offlinepatchsetting: l10n('appConstants.requestMapping.offlinepatchsetting'),
  offlinepspacksetting: l10n(
    'appConstants.requestMapping.offlinepspacksetting'
  ),
  onboardtenant: l10n('appConstants.requestMapping.onboardtenant'),
  patchdownload: l10n('appConstants.requestMapping.patchdownload'),
  patchrefresh: l10n('appConstants.requestMapping.patchrefresh'),
  postlcmupgrade: l10n('appConstants.requestMapping.postlcmupgrade'),
  powerOnVidm: l10n('appConstants.requestMapping.powerOnVidm'),
  prevalidatecreatesnapshot: l10n(
    'appConstants.requestMapping.prevalidatecreatesnapshot'
  ),
  prevalidaterevertsnapshot: l10n(
    'appConstants.requestMapping.prevalidaterevertsnapshot'
  ),
  prevalidateupgradeproduct: l10n(
    'appConstants.requestMapping.prevalidateupgradeproduct'
  ),
  producthealthcheck: l10n('appConstants.requestMapping.producthealthcheck'),
  productinventorysync: l10n(
    'appConstants.requestMapping.productinventorysync'
  ),
  productpatchinstall: l10n('appConstants.requestMapping.productpatchinstall'),
  pspackdownload: l10n('appConstants.requestMapping.pspackdownload'),
  pspackinstall: l10n('appConstants.requestMapping.pspackinstall'),
  pspackrefresh: l10n('appConstants.requestMapping.pspackrefresh'),
  reassigninternalnetworkrange: l10n(
    'appConstants.requestMapping.reassigninternalnetworkrange'
  ),
  replaceProductLicense: l10n(
    'appConstants.requestMapping.replaceProductLicense'
  ),
  scaleout: l10n('appConstants.requestMapping.scaleout'),
  searchusergrp: l10n('appConstants.requestMapping.searchusergrp'),
  selfpatchinstall: l10n('appConstants.requestMapping.selfpatchinstall'),
  snapshotProduct: l10n('appConstants.requestMapping.snapshotProduct'),
  snapshotProductRevert: l10n(
    'appConstants.requestMapping.snapshotProductRevert'
  ),
  snapshotProductRevertNodes: l10n(
    'appConstants.requestMapping.snapshotProductRevertNodes'
  ),
  sourcemapping: l10n('appConstants.requestMapping.sourcemapping'),
  systemupgrade: l10n('appConstants.requestMapping.systemupgrade'),
  tenantdetails: l10n('appConstants.requestMapping.tenantdetails'),
  testadconnection: l10n('appConstants.requestMapping.testadconnection'),
  triggeradsync: l10n('appConstants.requestMapping.triggeradsync'),
  updateadminpassword: l10n('appConstants.requestMapping.updateadminpassword'),
  updateaduserattributemappings: l10n(
    'appConstants.requestMapping.updateaduserattributemappings'
  ),
  updateauthproviderwithlcmhost: l10n(
    'appConstants.requestMapping.updateauthproviderwithlcmhost'
  ),
  updatedirectorydomains: l10n(
    'appConstants.requestMapping.updatedirectorydomains'
  ),
  updatedirusrngrpdns: l10n('appConstants.requestMapping.updatedirusrngrpdns'),
  updatelcmrootpassword: l10n(
    'appConstants.requestMapping.updatelcmrootpassword'
  ),
  updatenodepassword: l10n('appConstants.requestMapping.updatenodepassword'),
  updateProductCertificate: l10n(
    'appConstants.requestMapping.updateProductCertificate'
  ),
  updatevidmuserattributedefinitions: l10n(
    'appConstants.requestMapping.updatevidmuserattributedefinitions'
  ),
  upgradeproduct: l10n('appConstants.requestMapping.upgradeproduct'),
  upgradesaltminion: l10n('appConstants.requestMapping.upgradesaltminion'),
  valandonboardtenant: l10n('appConstants.requestMapping.valandonboardtenant'),
  validateandaddlicense: l10n(
    'appConstants.requestMapping.validateandaddlicense'
  ),
  validatelicense: l10n('appConstants.requestMapping.validatelicense'),
  validateonboardtenant: l10n(
    'appConstants.requestMapping.validateonboardtenant'
  ),
  validatemigrationinputs: l10n(
    'appConstants.requestMapping.validatemigrationinputs'
  ),
  validateupdateproductcertificate: l10n(
    'appConstants.requestMapping.validateupdateproductcertificate'
  ),
  validateupdateproductscertificate: l10n(
    'appConstants.requestMapping.validateupdateproductscertificate'
  ),
  verticalscaleupvalidation: l10n(
    'appConstants.requestMapping.verticalscaleupvalidation'
  ),
  validatewindowsdeploy: l10n(
    'appConstants.requestMapping.validatewindowsdeploy'
  ),
  vcentervalidate: l10n('appConstants.requestMapping.vcentervalidate'),
  vcinventorydiscovery: l10n(
    'appConstants.requestMapping.vcinventorydiscovery'
  ),
  vidmClusterHealthNotification: l10n(
    'appConstants.requestMapping.vidmClusterHealthNotification'
  ),
  vidmdirectorydelete: l10n('appConstants.requestMapping.vidmdirectorydelete'),
  vidmdirectorygroupslist: l10n(
    'appConstants.requestMapping.vidmdirectorygroupslist'
  ),
  vidmdirectorylist: l10n('appConstants.requestMapping.vidmdirectorylist'),
  vidmmigratetenant: l10n('appConstants.requestMapping.vidmmigratetenant'),
  vidmproductretrust: l10n('appConstants.requestMapping.vidmproductretrust'),
  vidmtriggerdryrun: l10n('appConstants.requestMapping.vidmtriggerdryrun'),
  vrablueprintexport: l10n('appConstants.requestMapping.vrablueprintexport'),
  vrccMigrationRequest: l10n(
    'appConstants.requestMapping.vrccMigrationRequest'
  ),
  vraEndpointCreation: l10n('appConstants.requestMapping.vraEndpointCreation'),
  vravagracefulbringup: l10n(
    'appConstants.requestMapping.vravagracefulbringup'
  ),
  vroinstallplugin: l10n('appConstants.requestMapping.vroinstallplugin'),
  vropsapuat: l10n('appConstants.requestMapping.vropsapuat'),
  windowsisocreation: l10n('appConstants.requestMapping.windowsisocreation'),
  migratetenantdirectories: l10n(
    'appConstants.requestMapping.migratetenantdirectories'
  ),
  tenantreferenceexists: l10n(
    'appConstants.requestMapping.tenantreferenceexists'
  ),
  tenantproductreferences: l10n(
    'appConstants.requestMapping.tenantproductreferences'
  ),
  tenantassociateproducts: l10n(
    'appConstants.requestMapping.tenantassociateproducts'
  ),
  togglefipsmode: l10n('appConstants.requestMapping.togglefipsmode'),
  verticalscaleuprequest: l10n(
    'appConstants.requestMapping.verticalscaleuprequest'
  ),
  vidmproductreregister: l10n(
    'appConstants.requestMapping.vidmproductreregister'
  ),
  vraretrustloadbalancer: l10n(
    'appConstants.requestMapping.vraretrustloadbalancer'
  ),
  vrnidspasswordvalidate: l10n(
    'appConstants.requestMapping.vrnidspasswordvalidate'
  ),
  vrnidspasswordupdate: l10n(
    'appConstants.requestMapping.vrnidspasswordupdate'
  ),
  vidmaddskipcertentry: l10n(
    'appConstants.requestMapping.vidmaddskipcertentry',
    [PRODUCT_SHORT.vidm]
  ),
  environmenthealthdisable: l10n(
    'appConstants.requestMapping.environmenthealthdisable'
  )
};

export const STATUS_MAPPING = {
  CREATED: l10n('created'),
  SUBMITTED: l10n('submitted'),
  COMPLETED: l10n('completed'),
  COMPLETED_WITH_WARNINGS: l10n('completedWithWarning'),
  PARTIALLY_COMPLETED: l10n('partiallyCompleted'),
  CANCELLED: l10n('cancelled'),
  FAILED: l10n('failed'),
  INPROGRESS: l10n('inProgress'),
  UI_INPROGRESS: l10n('pendingAction'),
  DELETED: l10n('deleted')
};

export const DEPLOY_OPTION_MAPPING = {
  'extra small': 'xsmall',
  small: 'small',
  medium: 'medium',
  large: 'large',
  'extra large': 'xlarge'
};

export const CERTIFICATE_KEYS_MAPPING = {
  period: l10n('lcops.settings.changeCertificate.certificateDetails.period'),
  expiresOn: l10n(
    'lcops.settings.changeCertificate.certificateDetails.expiresOn'
  ),
  issuedOn: l10n(
    'lcops.settings.changeCertificate.certificateDetails.issuedOn'
  ),
  healthy: l10n('lcops.settings.changeCertificate.certificateDetails.healthy'),
  subject: l10n('lcops.settings.changeCertificate.certificateDetails.subject'),
  issuer: l10n('lcops.settings.changeCertificate.certificateDetails.issuer'),
  san: l10n('lcops.settings.changeCertificate.certificateDetails.san'),
  algorithm: l10n(
    'lcops.settings.changeCertificate.certificateDetails.algorithm'
  ),
  keyAlgorithm: l10n(
    'lcops.settings.changeCertificate.certificateDetails.keyAlgorithm'
  ),
  sha256: l10n('lcops.settings.changeCertificate.certificateDetails.sha256'),
  keyLength: l10n(
    'lcops.settings.changeCertificate.certificateDetails.keyLength'
  ),
  sha1: l10n('lcops.settings.changeCertificate.certificateDetails.sha1')
};

export const UPGRADE_REPOSITORY_TYPES = {
  lcmrepository: l10n('appConstants.upgradeRepoTypes.vRSLCMRepository'),
  Default: l10n('appConstants.upgradeRepoTypes.vmwareRepository'),
  URL: l10n('appConstants.upgradeRepoTypes.local')
};

export const featureMinSupportedVersionPolicy = {
  minSupportedVersion: {
    vra: '7.6.0',
    vrbc: '7.5.0',
    vrops: '7.5.0',
    vrli: '4.8.0',
    vrni: '4.2.0',
    vidm: '3.3.1'
  }
};

export const GROUP_NAME_OTHER = l10n('appConstants.groupName.other');
export const GROUP_NAME_PROPERTIES = l10n('appConstants.groupName.properties');
export const VRNI_NODE_TYPES = ['vrni-platform', 'vrni-collector'];

export interface LabelMap {
  [name: string]: string;
}

export const ERROR_MESSAGE_NO_CERTIFICATE = l10n(
  'lcops.createEnvironment.products.noCertificateErrorMsg'
);

export const ERROR_MESSAGE_NO_CERTIFICATE_PRELUDE = l10n(
  'lcops.createEnvironment.products.noCertificateErrorMsgPrelude'
);

export const VRA_K8_CIDR_PATTER_ERROR_MESSAGE = l10n(
  'lcops.createEnvironment.products.vra_k8_cidr_patter_error_message'
);

export const COMPLETED_REQUEST_ALERT_MAPPING = {
  ENVIRONMENT_LOG_COLLECTION: l10n(
    'lcops.createEnvironment.products.envLogCollection'
  ),
  PRODUCT_LOG_COLLECTION: l10n(
    'lcops.createEnvironment.products.productLogCollection'
  )
};

export const IAAS_NODES = [
  'db',
  'iaas-dem-orchestrator',
  'iaas-dem-worker',
  'iaas-manager-active',
  'iaas-manager-passive',
  'iaas-web',
  'proxy-agent-vsphere',
  'windows-box'
];

export const DEFAULT_VRA_K8S_CLUSTER_CIDR = '10.244.0.0/22';
export const DEFAULT_VRA_K8S_SERVICE_CIDR = '10.244.4.0/22';

export function toRequestRedirectUrl(request: Request) {
  let redirectUrl = `${ROUTES.REQUESTS}/${request.vmid}`;

  const requestData = safeJsonParse(request.inputMap.requestData);
  const uiData = requestData && toSafeUIData(requestData.uiData);
  const isCloudProxyEnvironment = uiData && uiData.isCloudProxyEnvironment;

  if (request.state === 'UI_INPROGRESS') {
    if (request.requestName === RequestName.UpgradeProduct) {
      redirectUrl = `${ROUTES.UPGRADE_PRODUCT}/${request.vmid}`;
    } else if (request.requestName === RequestName.OnboardTenant) {
      redirectUrl = AuthznRouteConstants.AddTenant(request.vmid);
    } else if (request.requestName === RequestName.VidmMigrateTenantForUI) {
      redirectUrl = AuthznRouteConstants.NewTenantMigration(request.vmid);
    } else if (isCloudProxyEnvironment) {
      redirectUrl = `${CLOUD_ROUTES.CLOUD_PROXY}/${request.vmid}`;
    } else {
      redirectUrl = `${ROUTES.ENVIRONMENT_WORKFLOW}/${request.vmid}`;
    }
  }
  return redirectUrl;
}

export const EXTERNAL_URLS = {
  vRAReferenceArchitecture: l10n(
    'appConstants.externalUrl.vRAReferenceArchitecture'
  ),
  licenseUsageReport: l10n('appConstants.externalUrl.licenseUsageReport')
} as const;

export const toExternaVralUrl = (vraVersion: string) => {
  const version = vraVersion
    .split('.')
    .slice(0, 2)
    .join('.');
  return gte(version, '8.12')
    ? `https://docs.vmware.com/en/VMware-Aria-Automation/${version}/automation-reference-architecture/GUID-0332A798-93DA-435E-B45B-17A7233AE04F.html`
    : `https://docs.vmware.com/en/vRealize-Automation/${version}/reference-architecture/GUID-0332A798-93DA-435E-B45B-17A7233AE04F.html`;
};

export const MinVraVersionNeededForVssc = '8.3.0';

export function toDisplayNodeSize(key: string) {
  return (
    {
      xsmall: l10n('appConstants.nodeSize.xsmall'),
      small: l10n('appConstants.fieldGroups.small'),
      medium: l10n('appConstants.fieldGroups.medium'),
      large: l10n('appConstants.fieldGroups.large'),
      xlarge: l10n('appConstants.fieldGroups.xlarge'),
      xxlarge: l10n('appConstants.fieldGroups.xxlarge')
    }[key] || key
  );
}

export const UNSUPPORTED_UPGRADE_PLANNER_PRODUCTS = ['vrbc', 'vssc'];

export const MIN_VRA_VERSION_FOR_UPGRADE_PLANNER = '8.0.0';

export const CLOUD_PROXY_NTP_SUPPORTED_PRODUCTS = new Set([
  'vrnicloudproxy',
  'abxcloudproxy'
]);
